import type { ToasterProps } from 'svelte-sonner';
import { writable, type Writable } from 'svelte/store';

const additionalPaddingBottom = writable(0);
const isLockScroll = writable(false);
const callCSButtonStyle = writable('');
const toasterPosition: Writable<ToasterProps['position']> = writable('bottom-right');

export { additionalPaddingBottom, isLockScroll, callCSButtonStyle, toasterPosition };
